import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRegulatory = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	fill: "none",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1797 2.91895C12.4724 3.05089 11.6415 3.33529 10.3654 3.77213L9.69708 4.00088C6.1894 5.20157 4.43556 5.80192 3.99512 6.42944C3.56431 7.04324 3.5549 8.84132 3.55469 12.411L13.1797 9.20263V2.91895Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1797 11.0473L3.55469 14.2556V14.4899C3.55469 21.0676 8.50014 24.2597 11.603 25.6151C12.1989 25.8754 12.5838 26.0435 13.1797 26.1196V11.0473Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9297 26.1196V11.0473L24.5547 14.2556V14.4899C24.5547 21.0676 19.6092 24.2597 16.5064 25.6151C15.9105 25.8754 15.5256 26.0435 14.9297 26.1196Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9297 9.20263V2.91895C15.637 3.05089 16.4678 3.33529 17.744 3.77213L18.4123 4.00088C21.92 5.20157 23.6738 5.80192 24.1143 6.42944C24.5451 7.04324 24.5545 8.84132 24.5547 12.411L14.9297 9.20263Z",
			fill: "#808080"
		})
	]
});
const ForwardRef = forwardRef(SvgRegulatory);
export default ForwardRef;
